export default "__VITE_ASSET__6ee8b7e1__"